var _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHelpCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M17.0454 1.83172L16.1346 1.5906C14.6611 1.20058 13.126 1.10031 11.6144 1.29536C9.61818 1.55293 7.72134 2.31787 6.10491 3.51715L5.90339 3.66667L4.50044 4.87611C3.77877 5.49824 3.17717 6.24732 2.72544 7.08624C2.37983 7.72809 2.12589 8.41521 1.97104 9.12755L1.6731 10.4981C1.4545 11.5036 1.34425 12.5297 1.34425 13.5588V14.4015C1.34425 15.3254 1.48684 16.2438 1.76699 17.1243C2.27772 18.7295 2.3267 20.4459 1.90832 22.0776L0.944876 25.835C0.891842 26.0418 1.07769 26.2309 1.2854 26.1814L7.11438 24.7936C7.72851 24.6474 8.37128 24.6757 8.97018 24.8753L10.8727 25.5095C11.7037 25.7865 12.3706 26.4153 12.6959 27.2286C12.812 27.5188 12.9731 27.789 13.1732 28.0291L13.9041 28.9062C14.3611 29.4547 14.8746 29.9536 15.436 30.3946L15.8043 30.684C16.5962 31.3063 17.4846 31.7946 18.4343 32.1298C19.4209 32.478 20.4594 32.6559 21.5056 32.6559H22.8034C23.6326 32.6559 24.4575 32.5349 25.2517 32.2966C26.7199 31.8561 28.2797 31.8199 29.7667 32.1916L32.3927 32.8481C32.6689 32.9172 32.9197 32.6682 32.8526 32.3915L31.822 28.1401C31.694 27.6122 31.7571 27.056 32 26.5702C32.4336 25.7031 32.7011 24.7625 32.7889 23.797L32.8445 23.1856C32.9477 22.0508 32.8743 20.9069 32.6271 19.7945L32.5487 19.4414C32.3914 18.7335 32.1573 18.0448 31.8506 17.3877C31.3591 16.3345 30.6873 15.3753 29.8655 14.5535L29.2519 13.9399C28.8849 13.5729 28.4727 13.2539 28.0252 12.9907L26.8971 12.3271C26.1798 11.9052 25.6654 11.2091 25.4727 10.3995C25.1056 8.85792 24.3762 7.42613 23.3449 6.22297L21.8174 4.44086C20.4613 3.1978 18.8238 2.30246 17.0454 1.83172Z",
    fill: "white",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16289_46901",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 30,
    height: 30
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath3455"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3453",
    d: "M2.37646 2.37635H31.6238V31.6237H2.37646V2.37635Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16289_46901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3457"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3459",
    d: "M13.7378 23.8524C14.5202 27.7947 17.9977 30.7668 22.1698 30.7668C23.8949 30.7668 25.501 30.2583 26.8472 29.3836L30.3536 30.3535L29.3838 26.8471C30.2585 25.5008 30.7669 23.8948 30.7669 22.1697C30.7669 17.9975 27.7948 14.52 23.8525 13.7377",
    stroke: "#4D3CB4",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3463",
    d: "M13.5442 3.23319C7.84973 3.23319 3.2334 7.84952 3.2334 13.544C3.2334 15.5855 3.82686 17.4883 4.8504 19.0896L3.64669 23.4415L7.9986 22.2378C9.59994 23.2614 11.5027 23.8548 13.5442 23.8548C19.2387 23.8548 23.855 19.2385 23.855 13.544C23.855 7.84952 19.2387 3.23319 13.5442 3.23319Z",
    stroke: "#4D3CB4",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3465",
    d: "M14.4012 19.5706H12.6875V17.8568H14.4012V19.5706Z",
    fill: "#4D3CB4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3469",
    d: "M10.9736 10.9449C10.9736 9.52518 12.1245 8.37431 13.5442 8.37431C14.9639 8.37431 16.1148 9.52518 16.1148 10.9449C16.1148 11.6961 15.7924 12.3719 15.2786 12.8418L13.5442 14.4294V16.1431",
    stroke: "#4D3CB4",
    strokeMiterlimit: 10
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpCenter);
export default __webpack_public_path__ + "static/media/icon-help-center.0b18a4363bb1ac1cbdc1c96ecc5c54b1.svg";
export { ForwardRef as ReactComponent };